import { makeStyles } from '@material-ui/styles';
import { ShopwareProduct } from '@services/types/Shopware';
import { useEffect, useState } from 'react';
import StorefrontApiService from '@services/StorefrontApiService';
import ProductThumbnail from '@components/products/thumbnail';
import ProductPrice from '@components/page/product/price';
import { Typography } from '@material-ui/core';
import { useTranslation } from '@tools/i18n';
import Link from 'next/link';
import { getSeoUrl } from '@services/Utils';
import StockIndicator from '@components/products/partials/StockIndicator';

const useStyles = makeStyles({
    title: {
        marginBottom: 10,
        fontSize: 12,
        fontWeight: 300,
        letterSpacing: 0.5,
        textTransform: 'uppercase',
    },
    outletParent: {
        display: 'grid',
        gridTemplateColumns: '80px 1fr',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 32,
    },
    container: {},
    parent: {
        marginTop: '2rem',
        '& a': {
            textTransform: 'inherit',
            color: 'inherit',
            textDecoration: 'inherit',
        },
    },
    name: {},
    manufacturer: {
        textTransform: 'uppercase',
        fontFamily: 'serif',
        fontSize: '11px',
    },
    image: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        //borderRadius: '50%',
        height: 90,
        width: 90,
        //background: '#f6f6f7',
    },
    pricing: {
        '& > div': {
            marginTop: 4,
            paddingTop: 0,
        },
        '& span': {
            fontSize: '15px',
        },
    },
}, { name: 'OutletProduct' });

interface OutletParentProductProps {
    product: ShopwareProduct,
}

export default function OutletParentProduct({ product }: OutletParentProductProps) {
    const { t } = useTranslation(['product-info']);
    const classes = useStyles();
    const api = new StorefrontApiService();
    const [parent, setParent] = useState<ShopwareProduct | null>(null);
    // @ts-ignore
    const parentId = product?.customFields?.outlet_parent_id;

    useEffect(() => {
        getProduct();
    }, [parentId]);

    async function getProduct() {
        const id = parentId;
        const result = await api.getProductBySkus([id]);

        if (result?.products?.length) {
            setParent(result.products[0]);
        }
    }

    if (!parentId) {
        return null;
    }

    if (!parent) {
        return null;
    }

    const url = getSeoUrl(parent);

    return <section className={classes.parent}>
        <Typography className={classes.title}>{t('product-info:see-also-original-product')}</Typography>
        <Link href={url}>
            <a>
                <div className={classes.outletParent}>
                    <div className={classes.image}>
                        <ProductThumbnail useBackground={true} image={parent.cover}></ProductThumbnail>
                    </div>
                    <div className={classes.container}>
                        <div className={classes.manufacturer}>{parent.manufacturer?.translated?.name}</div>
                        <div className={classes.name}>{parent.name}</div>
                        <div className={classes.pricing}>
                            <ProductPrice product={parent}></ProductPrice>
                        </div>
                        <StockIndicator style={{marginTop: 4}} deliveryTimeId={parent.deliveryTimeId}></StockIndicator>
                    </div>
                </div>
            </a>
        </Link>
    </section>;
}
